<template>
  <div class="info-region-container" style="overflow:hidden">
    <div class="all-content-container" style="padding-top:15px;">
      <div class="container1 meun_x">
        <div class="titlemaun" style="padding: 20px;height: auto;">
          <div style="display: flex;align-items: center;">
            <p class="info-title">告警统计</p>
            <p class="backBth" @click="backBthCurrent()">
              <i class="el-icon-caret-left"></i>
              <span>返回</span>
            </p>
          </div>
          <el-radio-group v-model="tabPosition">
            <el-radio-button label="图表"></el-radio-button>
            <el-radio-button label="列表"></el-radio-button>
          </el-radio-group>
        </div>
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="大棚：">
            <el-cascader v-model="id" @change="change_val" :options="templateList" :props="optionProps"
              placeholder="请选择种植大棚" collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="传感器名称：">
            <el-select v-model="form.deviceId" @change="sensor_value" class placeholder="请选择传感器名称">
              <el-option clearable @change="sensor_value" v-for="item in sensorNameList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="属性名称：">
            <el-select clearable v-model="form.attributeId" class @change="attribute_value" placeholder="请选择属性名称">
              <el-option v-for="item in attributeLiST" :key="item.id" :label="item.cname" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期选择：">
            <el-select v-model="dateType" placeholder="请选择日期选择">
              <el-option v-for="item in timeList" :key="item.id" :label="item.name" clearable
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="value2" v-if="dateType == 7" type="datetimerange" @change="dateStartAndend"
              :picker-options="pickerOptions" range-separator="至" clearable start-placeholder="开始日期"
              end-placeholder="结束日期" align="right"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="onSubmit">查询</el-button>
            <el-button type="button" ass="button" @click="resetBth">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div v-if="show_val" class="el-table__empty-block" style=" height: 100%;">
        <span class="el-table__empty-text">暂无数据</span>
      </div> -->
      <div class="info-content-container" v-if="tabPosition == '图表'">
        <div id="main" style="width:100%;height:500px;"></div>
      </div>
      <div v-if="tabPosition == '列表'">
        <el-table border :data="tableData1" style="width: 100%">
          <el-table-column align="center" prop="alarmType" label="报警类型"></el-table-column>
          <el-table-column align="center" prop="num" label="数值"></el-table-column>
        </el-table>
        <br />
        <el-pagination style="padding-bottom:30px" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 15, 20, 25]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "alarmStatistics",
  data() {
    return {
      total2: 0,
      pageSize: 10,
      pageNum: 1,
      tableData1: [],
      tabPosition: "图表",
      show_val: false,
      value2: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },
      dateType: "",
      activeIndex: 11,
      pickerOptions: {},
      usertypeshow: "1",
      dateRange: "",
      form: {
        nameId: "",
        deviceId: "",
        attributeId: "",
        dateType: "",
      },
      attributeLiST: [],
      sensorNameList: [],
      value1: "",
      sceneListData: [],
      value: "",
      allSysUserList: [], //查询所有用户
      editId: "", //详情id（查询详情时使用））
      id: "",
      dialogTitle: "",
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      centerDialogVisible: false, //添加弹框

      timeList: [
        //0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
        {
          id: "0",
          name: "近10分钟",
        },
        {
          id: "1",
          name: "近20分钟",
        },
        {
          id: "2",
          name: "近30分钟",
        },
        {
          id: "3",
          name: "昨天",
        },
        {
          id: "4",
          name: "近7天",
        },
        {
          id: "7",
          name: "自定义",
        },
      ],
      formInline: {
        //查询条件（参数）
        name: "",
        sensorName: "",
        attributeName: "",
        dateType: "",
        updateTime: "",
      },
      dialogRules: {
        // 弹框表单验证
        titles: [
          { required: true, message: "请输入审批标题", trigger: "change" },
        ],
      },
      modelNoListData: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "管理员",
          id: 0,
        },
        {
          label: "普通用户",
          id: 1,
        },
      ],
      organizationList: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "武汉",
          id: 0,
        },
        {
          label: "上海",
          id: 1,
        },
      ],
      dialogformInline: [],
      tableData: [
        {
          date: "2016-05-07",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
      noneList: [],
      editId: "",
      templateList: [],

      iconId: "",
      endDate: "",
      startDate: "",
    };
  },
  watch: {
    tabPosition(val) {
      if (val == "图表") {
        this.getModelAttributeData();
      } else {
        this.getDataHisAlarmList();
      }
    },
  },
  created() {
    this.init();
    this.id = this.$route.query.id;
    this.getModelAttributeData(); //统计图
  },

  mounted() {
    //  this.initChart()
  },
  methods: {
    //开始时间和结束时间
    dateStartAndend(val) {
      this.endDate = this.zhDatetime1(val[1]) || ""; //结束时间
      this.startDate = this.zhDatetime1(val[0]) || ""; //开始时间
      this.getModelAttributeData(); //查询列表
    },
    zhDatetime1(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
    //大棚id
    change_val(val) {
      this.id = val[val.length - 1] || "";
      //this.getModelAttributeData(); //查询列表
      this.getNumericalsByGroupId(); //查询列表
    },
    // 查询大棚下的所有传感器
    getNumericalsByGroupId() {
      this.$api.system.getNumericals2(this.id).then((res) => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.sensorNameList = [];
            this.form.deviceId = "";
            this.form.attributeId = "";
          } else {
            this.sensorNameList = res.data;
            this.form.deviceId = res.data[0].id;
          }

          // this.getNumericalAttributeListTwo(res.data[0].id);
        }
      });
    },
    onSubmit() {
      if (this.dateType == "7") {
        this.endDate = ""
        this.startDate = ""
      }
      if (this.tabPosition == "图表") {
        this.getModelAttributeData();
      } else {
        this.getDataHisAlarmList();
      }
    },
    //弹框里的数据
    delnode(index) {
      this.noneList.splice(index, 1);
    },
    init() {
      this.getNumericals(); //查询全部传感器
      this.getAllGrowthCropsList();
    },
    backBthCurrent() {
      this.$router.push({
        name: "alarmPredictions",
        query: {
          currentShow: "third",
        },
      });
    },
    getAllGrowthCropsList() {
      console.log("断点111");
      this.$api.system
        .getGroupList()
        .then((res) => {
          if (res.code == 200) {
            this.templateList = res.data; //  种植大棚
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleCurrentChange(val) {
      //下一页
      this.pageNum = val;
      this.getDataHisAlarmList(); //查询列表
    },
    resetBth() {
      this.id = "";
      this.form.deviceId = "";
      this.form.attributeId = "";
      this.dateType = "";
      this.getModelAttributeData(); //查询列表
    },
    //    //查询属性
    sensor_value() {
      this.getModelRuleAttributes(this.form.deviceId);
    },
    //属性
    attribute_value() {
      if (this.form.cname == "1") {
        this.$message.error("请选择传感器名称");
      }
    },
    // 查询全部传感器
    getNumericals() {
      this.$api.system.getNumericals().then((res) => {
        if (res.code == 200) {
          this.sensorNameList = res.data; //全部传感器
        } else {
          this.$meessage.error(res.msg);
        }
      });
    },
    //查询全部属性名称
    getModelRuleAttributes(id) {
      this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          this.form.attributeId = res.data[0].id;
          var obj = {};
          obj.cname = "全部";
          obj.id = "";
          res.data.unshift(obj);
          this.attributeLiST = res.data; //全部告警模板
          // this.form.attributeId= res.data[0].id
        } else {
          this.$meessage.error(res.msg);
        }
      });
    },
    //查询告警统计图表
    getModelAttributeData() {
      let dateType
      this.$api.system
        .getModelAttributeData(
          this.form.attributeId, //属性id
          this.form.deviceId, //设备id
          this.id, //大棚id
          this.dateType, //时间段类型（0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
          this.endDate, //结束日期，格式yyyy-MM-dd HH:mm:ss
          this.startDate //开始日期，格式yyyy-MM-dd HH:mm:ss
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data.length == 0) {
              this.show_val = true;
            } else {
              this.show_val = false;
            }
            let xarr = [],
              yarr = [];
            for (let i = 0; i < res.data.length; i++) {
              xarr.push(res.data[i].alarmType);
              yarr.push(res.data[i].num);
            }
            this.initChart(xarr, yarr);
          } else {
            this.$meessage.error(res.msg);
          }
        });
    },
    //查询告警统计列表
    getDataHisAlarmList() {
      console.log(this.pageNum)
      this.$api.system
        .getDataHisAlarmList(
          this.form.attributeId, //属性id
          this.form.deviceId, //设备id
          this.id, //大棚id
          this.dateType, //时间段类型（0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
          this.endDate, //结束日期，格式yyyy-MM-dd HH:mm:ss
          this.startDate, //开始日期，格式yyyy-MM-dd HH:mm:ss
          this.pageNum,
          this.pageSize
        )
        .then((res) => {
          if (res.code == 200) {
            this.total2 = res.count;
            this.tableData1 = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getDataHisAlarmList();
    },
    drawLinez(datax, datayy, title) {
      var myChart = echarts.init(document.getElementById("main")); // 绘制折线图
      myChart.clear();
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          //formatter: "{a}: {c} ({d}%)"
        },
        legend: {
          data: title,
          top: 20,
        },
        markPoint: {
          type: "max",
        },
        /***** */
        markPoint: {
          data: [
            { type: "max", name: "最大值" },
            { type: "min", name: "最小值" },
          ],
        },
        markLine: {
          data: [{ type: "average", name: "平均值" }],
        },
        /****** */
        grid: {
          top: 60,
          left: 60,
          right: 100,
          bottom: 50,
        },
        xAxis: {
          name: "时间",
          nameTextStyle: {
            color: "#c1c1c1",
            padding: [46, 5, 5, 48],
            fontSize: 12,
          },
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#c1c1c1",
              fontSize: 10,
            },
            margin: 16, //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
          data: datax, //['17:22:00', '17:24:00', '17:26:00', '17:28:00', '17:30:00', '17:32:00', '17:34:00', '17:36:00', '17:38:00', '17:40:00', '17:42:00']
        },
        yAxis: {
          name: "数值",
          nameTextStyle: {
            color: "#54627D",
            //align:"right",
            padding: [80, 5, 10, -20],
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#54627D",
              fontSize: 10,
            },
            margin: 20, //刻度标签与轴线之间的距离。
          },
          type: "value",
          min: "100",
          max: "1000",

          splitNunber: 1,
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
        },
        series: datayy,
        //  [{
        //   data: datax,//[820, 932, 901, 934, 1290, 1130, 1020, 1120, 1340, 1220, 1520],
        //   type: 'line',
        //   smooth: true,
        //   symbolSize: 0,
        //   itemStyle : {
        //     normal : {
        //       color:'#0356FE',
        //       lineStyle:{
        //         color:'#0356FE'
        //       }
        //     }
        //   },
        //  areaStyle:{
        //       normal:{
        //           color:"#d2e9ef"
        //       }
        //   },//区域颜色渐变

        // }]
      });
    },
    // 图表
    initChart(xdata, ydata) {
      // console.log('*****');

      console.log(ydata);

      var myChart = echarts.init(document.getElementById("main"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },

        // toolbox: {
        //     show : true,
        //     feature : {
        //         dataView : {show: true, readOnly: false},
        //         magicType : {show: true, type: ['line', 'bar']},
        //         restore : {show: true},
        //         saveAsImage : {show: true}
        //     }
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: xdata == "" ? "" : xdata,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "数值",
            splitLine: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#256BFF", //坐标值得具体的颜色
              },
            },
            axisLine: {
              show: true, // Y轴线
              lineStyle: {
                //  type: 'dashed',
                color: "#256BFF",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#256BFF",
              },
            },
          },
        ],
        series: {
          barWidth: 30, //柱图宽度
          type: "bar",
          data: ydata,
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" },
            ],
          },
          markLine: {
            data: [{ type: "average", name: "平均值" }],
          },
        },
      };

      myChart.setOption(option);
    },
  },
};
</script>
<style >
@import "../../style/alarmTemplate.scss";
@import "../../style/approvalTemplate.scss";

/* @import "../../style/alarmTemplate.scss"; */
.backBth {
  cursor: pointer;
  margin-left: 20px;
}

.meun_x {
  position: relative;
}

.el-icon-caret-left {
  color: #326ff6;
}

.titlemaun {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-pagination {
  text-align: right;
}
</style>